'use client';

import { c as _c } from "react/compiler-runtime";
import { Trash2 } from 'lucide-react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
interface DeleteConfirmDialogProps {
  onConfirm: () => Promise<void> | void;
  description?: string;
  isLoading?: boolean;
  title?: string;
}
export const DeleteConfirmDialog = t0 => {
  const $ = _c(22);
  const {
    description: t1,
    isLoading: t2,
    onConfirm,
    title: t3
  } = t0;
  const description = t1 === undefined ? "Cette action ne peut pas \xEAtre annul\xE9e." : t1;
  const isLoading = t2 === undefined ? false : t2;
  const title = t3 === undefined ? "\xCAtes-vous s\xFBr ?" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AlertDialogTrigger asChild={true}><Button aria-label="Supprimer" className="hover:bg-red-50" size="icon" title="Supprimer" variant="ghost"><Trash2 className="h-4 w-4 text-red-600" /></Button></AlertDialogTrigger>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== title) {
    t5 = <AlertDialogTitle>{title}</AlertDialogTitle>;
    $[1] = title;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== description) {
    t6 = <AlertDialogDescription>{description}</AlertDialogDescription>;
    $[3] = description;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = <AlertDialogHeader>{t5}{t6}</AlertDialogHeader>;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isLoading) {
    t8 = <AlertDialogCancel disabled={isLoading}>Annuler</AlertDialogCancel>;
    $[8] = isLoading;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isLoading) {
    t9 = isLoading && <Spinner />;
    $[10] = isLoading;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isLoading || $[13] !== onConfirm || $[14] !== t9) {
    t10 = <AlertDialogAction className="bg-red-600 hover:bg-red-700" disabled={isLoading} onClick={onConfirm}>{t9}Supprimer</AlertDialogAction>;
    $[12] = isLoading;
    $[13] = onConfirm;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t8) {
    t11 = <AlertDialogFooter>{t8}{t10}</AlertDialogFooter>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t7) {
    t12 = <AlertDialog>{t4}<AlertDialogContent>{t7}{t11}</AlertDialogContent></AlertDialog>;
    $[19] = t11;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};